document.addEventListener("DOMContentLoaded", () => {
  const sliderWrappers = document.querySelectorAll(".match_it_slider_wrapper");

  sliderWrappers.forEach((wrapper) => {
    const slider = wrapper.querySelector(".match-it-slider");
    const slides = wrapper.querySelectorAll(".match-it-slide");
    const lookCount1 = wrapper.querySelectorAll(".look-1");
    const lookCount2 = wrapper.querySelectorAll(".look-2");
    const leftArrows = wrapper.querySelectorAll(".tetra_arrow.left");
    const rightArrows = wrapper.querySelectorAll(".tetra_arrow.right");
 
    let currentIndex = 0;
    let slideWidth = slides[0]?.offsetWidth || 0;

    const updateSlider = () => {
      if (!slider) return;

      slider.scrollTo({
        left: currentIndex * slideWidth,
        behavior: "smooth",
      });

      updateActiveState();
    };

    const updateActiveState = () => {
      slides.forEach((slide) => slide.classList.remove("active"));
      if (slides[currentIndex]) {
        slides[currentIndex].classList.add("active");
      }
      leftArrows.forEach((btn) => {
        btn.classList.toggle("active", currentIndex > 0);
      });

      rightArrows.forEach((btn) => {
        btn.classList.toggle("active", currentIndex < slides.length - 1);
      });

      lookCount1.forEach((btn) => {
        btn.classList.toggle("active", currentIndex > 0);
      });

      lookCount2.forEach((btn) => {
        btn.classList.toggle("active", currentIndex < slides.length - 1);
      });
    };
    window.addEventListener("resize", () => {
      slideWidth = slides[0]?.offsetWidth || 0;
      updateSlider();
    });

    leftArrows.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      });
    });

    rightArrows.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (currentIndex < slides.length - 1) {
          currentIndex++;
          updateSlider();
        }
      });
    });

    updateSlider();

    slider.addEventListener(
      "touchmove",
      (e) => {
        if (
          e.cancelable &&
          Math.abs(e.touches[0].clientX - startX) >
            Math.abs(e.touches[0].clientY - startY)
        ) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    let startX = 0;
    let startY = 0;

    slider.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: false }
    );

    slider.addEventListener("mousedown", (e) => {
      e.preventDefault();
    });
  });
});